import { useState, useEffect } from 'react'
import { MutableRefObject } from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
  } from "../components/ShadeDialog"
import { SlapId, Board } from '../utils/Primitives'
import { lookupExpandedSlap } from './Slaps'
import { getStickerUrl } from '../stickers/StickerDesigns';


export type DeleteSlapDialogProps = {
    boardRef: MutableRefObject<Board>,
    slapToDelete: SlapId | null;
    setOpenTimestamp : number;
    deletePendingSlap: (slapId: SlapId) => void;
}

export default function DeleteSlapDialog(props: DeleteSlapDialogProps) {
    const { boardRef, slapToDelete, setOpenTimestamp } = props;
    const [open, setOpen] = useState(false)
    const [lastOpenedAt, setLastOpenedAt] = useState(0)
    const expandedSlapToDelete = slapToDelete ? lookupExpandedSlap({boardRef, slapId: slapToDelete}) : null

    useEffect(() => {
        if (setOpenTimestamp != lastOpenedAt) {
            setOpen(slapToDelete ? true : false)
            setLastOpenedAt(setOpenTimestamp)
        }
    }, [slapToDelete, setOpenTimestamp, lastOpenedAt])

    const handleConfirmDelete = (slapId: SlapId | null) => {
        if (slapToDelete) {
            props.deletePendingSlap(slapToDelete)
        }
        setOpen(false)
    }

    if (!expandedSlapToDelete) {
        return null
    }

    return (
        <div className='mt-2 mb-3'>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className='bg-white text-slate-900 w-64'>
                    <DialogHeader>
                        <DialogTitle>Delete Pending Slap?</DialogTitle>
                        <div className='my-8 flex flex-col justify-center items-center'>
                            <p className='my-4 text-sm'>
                                Place: {expandedSlapToDelete.place.id}
                            </p>

                            <div className='mb-4'>
                                <img src={getStickerUrl(expandedSlapToDelete.sticker)} alt={expandedSlapToDelete.sticker.name} className="h-20 w-16" />
                                <div className='py-1 w-14 text-sm text-center'>{expandedSlapToDelete.sticker.name}</div>
                            </div>

                            <button className='bg-gradient-to-r from-red-600 to-orange-400
                                    text-white font-bold
                                    mt-4 mb-2 py-2 px-4 rounded-lg w-32'
                                    onClick={(e) => handleConfirmDelete(slapToDelete)}
                            >
                                Delete
                            </button>
                        </div>
                    </DialogHeader>
                </DialogContent>
            </Dialog>
        </div>
    )
}
